module.exports = __webpack_public_path__ + "static/media/red-velvet.40dc061a.png";